module.exports = __webpack_public_path__ + "img/ic_appraisal_id.ffbaf5fb.svg";